import { IconComponent } from './types';

const HistoryIcon: IconComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="currentColor"
        d="M6.857 1c-2.84 0-5.143 2.239-5.143 5H0l2.223 2.161.04.078L4.57 6H2.857c0-2.15 1.789-3.889 4-3.889 2.212 0 4 1.739 4 3.889 0 2.15-1.788 3.889-4 3.889a4.025 4.025 0 0 1-2.823-1.145l-.811.79A5.19 5.19 0 0 0 6.857 11C9.697 11 12 8.761 12 6S9.697 1 6.857 1Zm-.571 2.778v2.778l2.445 1.41.412-.672-2-1.155V3.778h-.857Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path d="M0 0h12v12H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default HistoryIcon;
